module.exports = __webpack_public_path__ + "img/10-bis.d5fde191.png";